export const SHOPIFY_INTEGRATION_TYPE = 'shopify';
export const WOO_COMMERCE_INTEGRATION_TYPE = 'woo_commerce';
